import { getFallbackValueIfNull } from 'owa-options-core';
import store from '../store/store';
import { getUserConfiguration } from 'owa-session-store';
import { select } from 'satcheljs/lib/legacy';
export default select({
    optionState: function () { return store; },
    userOptions: function () { return getUserConfiguration().UserOptions; },
})(function isMessageFormatOptionDirty(state) {
    var optionState = state.optionState, userOptions = state.userOptions;
    return (getFallbackValueIfNull(optionState.showBcc, userOptions.AlwaysShowBcc) !==
        userOptions.AlwaysShowBcc ||
        getFallbackValueIfNull(optionState.showFrom, userOptions.AlwaysShowFrom) !==
            userOptions.AlwaysShowFrom ||
        getFallbackValueIfNull(optionState.composeFormat, userOptions.ComposeMarkup) !==
            userOptions.ComposeMarkup ||
        getFallbackValueIfNull(optionState.fontFamily, userOptions.ComposeFontName) !==
            userOptions.ComposeFontName ||
        getFallbackValueIfNull(optionState.fontSize, userOptions.ComposeFontSize) !==
            userOptions.ComposeFontSize ||
        getFallbackValueIfNull(optionState.fontColor, userOptions.ComposeFontColor) !==
            userOptions.ComposeFontColor ||
        (optionState.isFontBold !== null &&
            !!(userOptions.ComposeFontFlags & 1 /* Bold */) !== optionState.isFontBold) ||
        (optionState.isFontItalic !== null &&
            !!(userOptions.ComposeFontFlags & 2 /* Italic */) !== optionState.isFontItalic) ||
        (optionState.isFontUnderline !== null &&
            !!(userOptions.ComposeFontFlags & 4 /* Underline */) !== optionState.isFontUnderline));
});
//# sourceMappingURL=isMessageFormatOptionDirty.js.map